

interface EditorialSearchSectionProps {
  onSearch?: (query: string) => void
  onCategoryChange?: (category: string) => void
  selectedCategory?: string
}

export default function EditorialSearchSection({ onSearch, onCategoryChange, selectedCategory = 'ALL' }: EditorialSearchSectionProps) {
  const menuOptions = [
    'ALL',
    'Architecture & Design',
    'Art & Culture',
    'Beauty & Wellness',
    'Business',
    'Food & Drinks',
    'Lifestyle',
    'Restaurants & Nightlife',
    'Style & Fashion',
    'Travel',
    'Weddings'
  ]

  const handleCategoryClick = (category: string) => {
    onCategoryChange?.(category)
  }

  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value
    onSearch?.(query)
    // Reset category to ALL when searching
    if (query && selectedCategory !== 'ALL') {
      onCategoryChange?.('ALL')
    }
  }

  return (
    <section
      id="editorial-search-section"
      className="w-full flex items-center justify-center"
      style={{
        height: '140px',
        backgroundColor: '#FFFFFF',
        paddingTop: '64px'
      }}
    >
      <div className="flex flex-col items-center">
        {/* Title */}
        <p
          className="text-center"
          style={{
            fontFamily: 'Cardo',
            fontSize: '22px',
            fontStyle: 'italic',
            color: '#000000',
            marginBottom: '30px',
            textAlign: 'center'
          }}
        >
          Prestige Editorial. Expertly Curated.
        </p>


        {/* Menu Options */}
        <div
          className="flex flex-wrap items-center justify-center"
          style={{
            gap: '16px',
            marginBottom: '16px'
          }}
        >
          {menuOptions.map((option, index) => (
            <button
              key={index}
              className={`hover:opacity-70 transition-opacity duration-200 ${selectedCategory === option ? 'font-bold' : ''}`}
              style={{
                fontFamily: 'Plus Jakarta Sans',
                fontSize: '11px',
                fontWeight: selectedCategory === option ? '700' : '500',
                color: '#000000',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                textTransform: 'uppercase'
              }}
              onClick={() => handleCategoryClick(option)}
            >
              {option}
            </button>
          ))}
        </div>

      </div>
    </section>
  )
}